<div class="exprx--common-block  insurance--body">
    <div class="eprx--block__header text-white ps-3 fw-bold">
        <div class="row">
            <div class="col-11">
                Patient Details
            </div>
            <div class="col-1 ps-0 patient-edit--transfer-in" *ngIf="selectedPatientDetails?.patientid  && !selectedPatientDetails?.requestedInfo && !IsfrmPatHis" 
            >
                <i   [ngClass]="IsfrmPatHis? 'color_light_gray ' : ''" (click)="IsfrmPatHis ? '' : editPatient(selectedPatientDetails.patientid)"
                class="far  fa-edit" appCustomTooltip="Patient Edit"></i>
            </div>
        </div>
    </div>
    <div
    class="eprx--block__content  pt-0"
[ngClass]="requestedInfor? (IsFromProcess && (!PatientNotFound || CurrentDetails?.PatientFound > 1) ? 'cards_height_transferIn' : 'height_236') :(IsTransferType ? 'cards_height_mark_transferIn' : 'cards_height_transferIn')">
        <div class="seconday-search--grid dashboard--search lg-secondary-search--grid row-space-transfer-in mb-0" *ngIf="(!selectedPatientDetails?.requestedInfo && !requestedInfor) || (!PatientNotFound && IsFromProcess) || (CurrentDetails?.PatientFound > 1 && IsFromProcess)">
    <app-searchbox-global class="w-100" #PatSear [SearchFor]="'Patient'" [DisableSerchFil]="true" class="eRx_transfer-request" [DisableRadioButtons]="true" [IsHide]="true" 
    [IsMultiMatch]="isMultiPatient && !isPatientReselected ? {
        pName: (selectedPatientDetails?.fullname?.toUpperCase()?.replace('_', ', ')) , pDob : (selectedPatientDetails?.dob)
    } : ''" (SelectedPatient)="checkIsActivePatient($event, false, true)"  [isFrmAllergies]="true" [IsTransferObj]="!isPatientReselected ? CurrentDetails : null"
    [inputdisabled]="(SelectedRecords?.length) ? false : isfromPatientHistory"  [IsModalClass]="'max-modal-lg-size'"
    [IsClearIConDisable]="(IsFromProcess && isPatientNewlyAdded) || ((SelectedRecords?.length) ? false : isfromPatientHistory)" [IsClearMultiPatient]="isPatientReselected"
     id="NewRxPatSearforeRx" [IsPatientNewlyAdded] = "(IsFromProcess && isPatientNewlyAdded)" [IsFocused]="isFocus"  [ClearInputValue]="patientSearchValue" [SearchFrm]="'patSelection'" [PatientDetails]="selectedPatientDetails"
        ></app-searchbox-global>
  </div> 
    <div class="row row-space-transfer-in" >
        <div class="col-6 erx__Patient--section">
            <span>
                <label>{{patientLabels.Name}}</label>&nbsp;
                <i [ngbTooltip]="(selectedPatientDetails && selectedPatientDetails?.PatientFoundMsg) ? selectedPatientDetails?.PatientFoundMsg : !PatientNotFound ? (IsPush ? 'The selected patient could not be found.' : 'The requested patient could not be found.') : (PatientNotFound > 1 ? ( IsPush ? 'The selected patient matches multiple records' : 'The requested patient matches multiple records') : (IsPush ? 'The selected patient  has been found.' : 'The requested patient  has been found.'))" triggers="mouseenter:mouseleave"
                placement="bottom-start" tooltipClass="search-tooltip title-tooltip"   *ngIf="(IsFromProcess || (IsPush && CurrentDetails)) && selectedPatientDetails && !isPatientOverride"  
                [ngClass]="(!CurrentDetails?.PatientFound) ? 'far fa-times-circle' : (CurrentDetails?.PatientFound > 1 ? 'far fa-exclamation-circle' : 'far fa-check-circle')" aria-hidden="true"></i>
            </span> 
            <div  [ngbTooltip]="(!IsfrmPatHis && !IsTitle) ? ((selectedPatientDetails?.fullname)? (selectedPatientDetails?.fullname) : '') : ''" triggers="mouseover:mouseleave"
             placement="bottom-start" [title]="(IsfrmPatHis || IsTitle) ? selectedPatientDetails?.fullname: ''" [autoClose]="true" tooltipClass="search-tooltip title-tooltip">
             {{selectedPatientDetails ?
                    (selectedPatientDetails?.fullname) : msgConfig.EMPTY_Data}}
            </div>
        </div>
        <div class="col-3">
            <label>{{patientLabels.DOB}}</label>
            <div class="label--data"><span>{{selectedPatientDetails ?
                    (selectedPatientDetails?.dob | date: "MM/dd/yyyy" ) : msgConfig.EMPTY_Data}}</span></div>
        </div>
        <div class="col-3">
            <label>{{patientLabels.Gender}}</label>
            <div class="label--data"><span>{{selectedPatientDetails ?
                    (selectedPatientDetails?.gender) : msgConfig.EMPTY_Data}}</span></div>
        </div>
    </div>
    <div class="row row-space-transfer-in">
        <div class="col-6">
            <label>{{patientLabels.Insurance_Type_Code}}</label>
            <div class="label--data"><span>{{(primaryInsu?.InsurerCode) ? (primaryInsu?.InsurerCode
                    | uppercase) : msgConfig.EMPTY_Data}} ({{(primaryInsu?.groupname) ? (primaryInsu?.groupname
                        | uppercase) : msgConfig.EMPTY_Data}}/{{(primaryInsu?.binnum) ? (primaryInsu?.binnum
                        | uppercase) : msgConfig.EMPTY_Data}}/{{(primaryInsu?.ProcessorNum) ? (primaryInsu?.ProcessorNum
                            | uppercase) : msgConfig.EMPTY_Data}})</span></div>
        </div>
        <div class="col-6">
            <label>{{patientLabels.Patient_notes}}</label>
            <div class="label--data ellpise text_transform"  [ngbTooltip]="(!IsfrmPatHis && !IsTitle) ? selectedPatientDetails?.notes : ''" triggers="mouseenter:mouseleave"  
            [title]="(IsfrmPatHis || IsTitle) ? selectedPatientDetails?.notes : ''"  placement="top-start" tooltipClass="search-tooltip title-tooltip"><span>{{(selectedPatientDetails?.notes) ?
                    selectedPatientDetails?.notes : msgConfig.EMPTY_Data}}</span></div>
        </div>
    </div>
    <div class="row row-space-transfer-in">
        <div class="col-6">
            <label>{{patientLabels.Phone}}</label>
            <div class="label--data ellpise">
                <span [ngClass]="isIvrEnabled && selectedPatientDetails?.mobile ? 'ivr-mob' : ''" (click)="clickToCallOutBond(selectedPatientDetails?.mobile)">{{selectedPatientDetails?.mobile ? (selectedPatientDetails?.mobile | mask : "(000)000-0000"):""}}</span><span>{{selectedPatientDetails?.mobile && selectedPatientDetails?.telephone ? ',' : !selectedPatientDetails?.mobile && !selectedPatientDetails?.telephone ? '--' : ''}}&nbsp;</span>
                <span [ngClass]="isIvrEnabled && selectedPatientDetails?.telephone ? 'ivr-mob' : ''" (click)="clickToCallOutBond(selectedPatientDetails?.telephone)">{{selectedPatientDetails?.telephone ? (selectedPatientDetails?.telephone | mask : "(000)000-0000"):""}}</span>
            </div>
        </div>
        <div class="col-6">
            <label>{{patientLabels.Address}}</label>
            <div class="label--data ellpise"
            [ngbTooltip]="(!IsfrmPatHis && !IsTitle) ? (selectedPatientDetails?.address)? (selectedPatientDetails?.address | uppercase) :'' : ''" triggers="mouseenter:mouseleave"
             placement="top-start" tooltipClass="search-tooltip title-tooltip" 
             [title]=" (IsfrmPatHis || IsTitle) ? (selectedPatientDetails?.address)? (selectedPatientDetails?.address | uppercase) :'' : ''"
            > 
            <span *ngIf="!(SelectedRecords?.length)">{{(selectedPatientDetails?.address) ?
                    selectedPatientDetails?.address : msgConfig.EMPTY_Data}}</span>
                      <span *ngIf="selectedPatientDetails?.fulladdress && (SelectedRecords?.length)">{{(selectedPatientDetails?.fulladdress) ?
                    selectedPatientDetails?.fulladdress : msgConfig.EMPTY_Data}}</span>
                </div>
        </div>
    </div>
    <div class="row row-space-transfer-in">
        <div class="col-12">
            <label>{{patientLabels.Allergies}}</label>
            <div class="label--data tranfer-in-sig-allergies-height"
            [ngClass]="selectedPatientDetails?.AllergiesList?.includes(msgConfig.No_Known_Allergies) ? '' : 
                                    (selectedPatientDetails?.AllergiesList?.length ? 'allergy-color' : '')">
                <span>
                    {{selectedPatientDetails?.AllergiesList ?
                    selectedPatientDetails?.AllergiesList.join(", ") : msgConfig.EMPTY_Data}}
                </span>
            </div>
        </div>
    </div>
</div>
</div>
